import { Button, Modal, ModalActions, ModalContent, ModalHeader, Text, } from '@lightspeed/design-system-react';
import { useT } from '@transifex/react';
import { trackUserEvent } from '@vend/utilities';
import React from 'react';
import { withTranslations } from '../../tx';
import { UBE_MODULE_COMPROMISED_PASSWORD } from './constants';
const PasswordCompromisedAlertModalUnconnected = ({ isSubmitting, onChangePassword, onIgnore, onClose, authType = 'signin', dismissable = true, }) => {
    const t = useT();
    const handleIgnore = async () => {
        trackUserEvent(UBE_MODULE_COMPROMISED_PASSWORD, 'Not Now Clicked');
        onIgnore();
    };
    const isSignin = authType === 'signin';
    return (React.createElement(Modal, { focusTrapActive: !isSignin, size: "small", pageModal: isSignin, onClose: onClose, dismissable: dismissable },
        React.createElement(ModalHeader, null,
            React.createElement("div", { className: "vd-flex vd-flex--align-center" },
                React.createElement("div", { className: "vd-text-heading" }, t('Change your password to keep your account secure', {
                    _context: 'password compromised alert - modal header',
                })))),
        React.createElement(ModalContent, null,
            React.createElement(Text, null, t('Lightspeed Retail has found your password in a third-party data breach, which puts your account at risk of being compromised. We recommend changing your password immediately.', { _context: 'password compromised alert - modal content' }))),
        React.createElement(ModalActions, { className: "right-align" },
            React.createElement(React.Fragment, null,
                React.createElement(Button, { "data-track": "password-compromised-alert-modal-not-now", className: "vd-mr2", variant: "supplementary", onClick: handleIgnore, loading: isSubmitting }, t('Not now', {
                    _context: 'password compromised alert - modal action button',
                })),
                React.createElement(Button, { "data-track": "password-compromised-alert-modal-change-password", variant: "go", onClick: onChangePassword, disabled: isSubmitting, autoFocus: true }, t('Change password', {
                    _context: 'password compromised alert - modal action button',
                }))))));
};
export const PasswordCompromisedAlertModal = withTranslations(PasswordCompromisedAlertModalUnconnected, 
// eslint-disable-next-line i18next/no-literal-string
'PasswordCompromisedAlert');
